'use client';

import React from 'react';
import Link from 'next/link';

export default function TableOfContents({ items = [] }) {
    if (items.length === 0) return null;

    const handleScroll = (e, id) => {
        e.preventDefault();
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            window.history.pushState(null, '', `#${id}`);
        }
    };

    return (
        <div className="flex flex-col gap-3">
            <ul className="flex flex-col gap-1">
                {items.map((item, index) => (
                    <li key={index} className="flex gap-3 items-baseline group">
                        <span className="text-[13px] font-semibold text-custom-orange-800 min-w-[20px] shrink-0 tabular-nums">{String(index + 1).padStart(2, '0')}</span>
                        <Link
                            href={`#${item.id}`}
                            onClick={(e) => handleScroll(e, item.id)}
                            className="custom-text-base text-base border-b border-transparent transition-all duration-200 hover:text-custom-orange-800 hover:border-custom-orange-800"
                        >
                            {item.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
